import type { Tone } from '~/types/game';

interface BarProps {
  /** Percent 0..100. */
  pct: number;
  tone?: Tone | '';
}

/** Linear progress bar. Composes with the `.bar` and `.bar.<tone>` CSS classes. */
export function Bar(props: BarProps) {
  return (
    <div class={`bar ${props.tone ?? ''}`}>
      <i style={{ width: `${Math.max(0, Math.min(100, props.pct))}%` }} />
    </div>
  );
}
